var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, Divider, IconButton, Menu, MenuItem, Stack } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
/**
 * A responsive action menu. Shows a labelled, collapsed "⋮" menu on mobile (and
 * on desktop when `forceMenu` is set); otherwise a row of icon buttons.
 */
export var ResponsiveActionMenu = function (_a) {
    var actions = _a.actions, isMobile = _a.isMobile, _b = _a.forceMenu, forceMenu = _b === void 0 ? false : _b;
    var _c = __read(useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    var open = Boolean(anchorEl);
    var handleMenuOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
    };
    if (actions.length === 0)
        return null;
    if (isMobile || forceMenu) {
        return (_jsxs(Box, { sx: {
                minWidth: 0,
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
            }, children: [_jsx(IconButton, { onClick: handleMenuOpen, "aria-label": "Team actions", children: _jsx(MoreVertIcon, {}) }), _jsx(Menu, { anchorEl: anchorEl, open: open, onClose: handleMenuClose, anchorOrigin: { vertical: "bottom", horizontal: "right" }, transformOrigin: { vertical: "top", horizontal: "right" }, keepMounted: true, children: actions.flatMap(function (action, index) {
                        var item = (_jsxs(MenuItem, { component: action.to ? Link : "li", to: action.to, onClick: function () {
                                var _a;
                                handleMenuClose();
                                (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action);
                            }, sx: action.destructive ? { color: "error.main" } : undefined, children: [_jsx(Box, { component: "span", sx: { mr: 1, display: "flex" }, children: action.icon }), action.label] }, index));
                        return action.divider
                            ? [_jsx(Divider, {}, "divider-".concat(index)), item]
                            : [item];
                    }) })] }));
    }
    return (_jsx(Stack, { direction: "row", spacing: 1, children: actions.map(function (action, index) {
            return action.to ? (_jsx(IconButton, { component: Link, to: action.to, "aria-label": action.label, title: action.label, children: action.icon }, index)) : (_jsx(IconButton, { onClick: action.onClick, "aria-label": action.label, title: action.label, children: action.icon }, index));
        }) }));
};
